import * as interviewService from "../../services/InterviewService";
import moment from "moment";
import { normalizeJson } from "../../../shared/helpers";
import { useMainStore } from "../store";
import { useRepo } from "pinia-orm";
import { defineStore } from "pinia";
import InterviewAnswer from "../../models/InterviewAnswer";
import Interview from "../../models/Interview";

function initialState() {
    return {
        filterValues: {},
    };
}

export const useInterviewStore = defineStore('interviewsModule', {
    state: () => ({
        ...initialState(),
        mainStore: useMainStore(),
    }),
    getters: {
        getURLParametersForFilter(state) {
            const params = {};

            if (state.filterValues.date_from) {
                params['filter[date_from]'] = state.filterValues.date_from?.format();
            }

            if (state.filterValues.date_to) {
                params['filter[date_to]'] = state.filterValues.date_to?.format();
            }

            if (state.filterValues.new) {
                params['filter[new]'] = state.filterValues.new;
            }

            if (state.filterValues.hired) {
                params['filter[hired]'] = state.filterValues.hired;
            }

            if (state.filterValues.stages?.length) {
                params['filter[stage_id]'] = state.filterValues.stages.map(stage => {
                    const parts = stage.split(':');
                    return parts[parts.length - 1];
                }).join(',');
            }

            if (state.filterValues.text_keyword !== '') {
                params['filter[keyword]'] = state.filterValues.text_keyword;
            }

            if (state.filterValues.tags && state.filterValues.tags.length) {
                params['filter[tag_id]'] = state.filterValues.tags.join(',');
                params['tag_mode'] = state.filterValues.inclusiveTagMode ? 'and' : 'or';
            }

            if (state.filterValues.today) {
                params['filter[starts_at]'] = moment().format('YYYY-MM-DD');
            }

            if (state.filterValues.completed) {
                params['filter[completed]'] = state.filterValues.completed;
            }

            if (state.filterValues.statuses.length) {
                params['filter[status_id]'] = state.filterValues.statuses.join(',');
            }

            if (state.filterValues.jobfunctions?.length) {
                params['filter[job_id]'] = state.filterValues.jobfunctions.join(',');
            }

            if (state.filterValues.users?.length) {
                params['filter[user_id]'] = state.filterValues.users.join(',');
            }

            return params;
        },
    },
    actions: {
        async setAnswersForTemplateQuestions({ interviewId, template }) {
            const locale = this.mainStore.locale;
            const questions = template.questions.filter(question => {
                return question.question[locale] ? question.question[locale].trim().toLowerCase() : null;
            });

            for (let index = 0; index < questions.length; index++) {
                const question = questions[index];

                await interviewService.createAnswer(interviewId, {
                    data: {
                        attributes: { question: question.question[locale], answer: '' },
                        relationships: {
                            interview: {
                                data: {
                                    type: 'interviews',
                                    id: interviewId,
                                },
                            },
                        },
                    },
                }).then(result => {
                    return useRepo(InterviewAnswer).save(normalizeJson(result));
                });
            }
        },
        setFilterValues(values) {
            this.filterValues = values;
        },
        resetState() {
            // Instead of resetting the state entirely, we want to keep track
            // of the filter values which were set before.
            // If we switch pages or change order sequence, we want to use
            // the same filter values.
            const newState = initialState();

            delete newState.filterValues;
            delete newState.sequence;

            Object.assign(this, newState);

            // delete all applications so we will reload them
            this.clearInterviews();
        },
        clearInterviews() {
            useRepo(Interview).flush();
        }
    }
});
